import { ReactNode } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { localizePercentageValue } from 'utils/i18nHelpers';
import { InsightPanel } from './InsightPanel';
import { InsightPanelPlaceholder } from './InsightPanelPlaceholder';
import { InsightType } from '../domain';

export type PercentageInsightPanelProps = {
  title: string;
  children?: ReactNode;
  percentage?: number;
  showSelect?: boolean;
  isLoading?: boolean;
  isEmpty?: boolean;
};

const PercentageWrapper = styled.div`
  font-size: ${({ theme }) => theme.spacing.values.x3};
  line-height: ${({ theme }) => theme.spacing.utils.pxToRem(56)};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
  padding-bottom: ${({ theme }) => theme.spacing.values.base};
`;

const StyledSkeleton = styled(Skeleton)`
  margin-bottom: ${({ theme }) => theme.spacing.values.threeQuarter};
  height: ${({ theme }) => theme.spacing.values.x4};
  padding: ${({ theme }) => theme.spacing.values.threeQuarter} 0;
`;

export const PercentageInsightPanel = ({
  children,
  title,
  showSelect,
  percentage = 0,
  isLoading = false,
  isEmpty = false,
}: PercentageInsightPanelProps) => {
  const localizedPercentageValue = localizePercentageValue(percentage, false);

  return !isEmpty ? (
    <InsightPanel title={title} colSpan={2} showSelect={showSelect}>
      {isLoading ? (
        <StyledSkeleton />
      ) : (
        <>
          <PercentageWrapper>{localizedPercentageValue}</PercentageWrapper>
          {children}
        </>
      )}
    </InsightPanel>
  ) : (
    <InsightPanelPlaceholder colSpan={2} title={title} type={InsightType.behavioral} />
  );
};
